import { useCallback } from 'react';

import { IEntityComponentProps } from '~interfaces/props';
import { AnnotationsCanvas } from './AnnotationsCanvas';
import { Annotation, AnnotationDragDescriptor, annotationToRaw, rawToAnnotation } from './AnnotationUtils';

export type AnnotationsCanvasContainerProps = {
  editing: boolean;
  entity: Entity;
  onChange: IEntityComponentProps['onChange'];
  onMouseOver: (id: string) => void;
  onMouseOut: (id: string) => void;
  onClick: (id: string) => void;
  focusMarkerId: string;
  items: Annotation[];
};

export const AnnotationsCanvasContainer = ({
  editing,
  entity,
  onChange,
  onMouseOut,
  onMouseOver,
  onClick,
  focusMarkerId,
  items,
}: AnnotationsCanvasContainerProps) => {
  const handleChangeItem = useCallback(
    (move: AnnotationDragDescriptor) => {
      if (editing) {
        const idx = move.id;
        const rawAnnotation: string = entity.attributes.field_annotations_items[idx];
        const anno = rawToAnnotation(rawAnnotation);
        const newAnno: Annotation = { ...anno, position: [move.left, move.top] };
        const newRawAnno = annotationToRaw(newAnno);
        onChange(`attributes.field_annotations_items.${idx}`, newRawAnno);
      }
    },
    [editing, entity, onChange],
  );

  return items ? (
    <AnnotationsCanvas
      items={items}
      editing={editing}
      onChange={handleChangeItem}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={onClick}
      focusItemId={focusMarkerId}
    />
  ) : null;
};
